import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ColorService {
    readonly tilePaletteColors: string[] = [
        '#f51e21',
        '#f23c86',
        '#aa5ad2',
        '#69f4ff',
        '#0f82ff',
        '#64bef8',
        '#0fb941',
        '#50d2a5',
        '#fa8b00',
        '#f5c200',
        '#9191a0',
        '#efabab',
    ];

    /**
     * @returns A string array with the colors for automatically coloring the charts for data that has no color setting.
     */
    getChartAutoColors(): string[] {
        return this.tilePaletteColors;
    }

    /**
     * @returns A string array with the colors for the color palette for tile coloring.
     */
    getTileColorPalette(): string[] {
        return this.tilePaletteColors;
    }
}
